module.exports = __webpack_public_path__ + "static/img/hezhongLogo_bg.aac5584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hezhongLogo_bg.png
// module id = 6SAx
// module chunks = 12